import { Text } from '@tribeplatform/react-ui-kit/Text'

import { T } from '../../i18n/index.js'

interface Props {
  archived?: boolean
}

export const EmptyChatListState = ({ archived }: Props) => {
  return (
    <div className="flex flex-col gap-y-2 items-center justify-center h-full text-center p-4">
      <Text className="font-semibold">
        {archived ? (
          <T
            defaultMessage="No Archived Chats."
            id="Messaging.Sidebar.EmptyChatListState.Archived.Title"
          />
        ) : (
          <T
            defaultMessage="No Chats"
            id="Messaging.Sidebar.EmptyChatListState.Title"
          />
        )}
      </Text>
      <Text className="text-content-muted">
        {archived ? (
          <T
            defaultMessage="Move conversations here to keep things tidy."
            id="Messaging.Sidebar.EmptyChatListState.Archived.Description"
          />
        ) : (
          <T
            defaultMessage="You can start a chat by clicking on the new chat button and start a conversation."
            id="Messaging.Sidebar.EmptyChatListState.Description"
          />
        )}
      </Text>
    </div>
  )
}
